import React from 'react'
import TopTenBuyers from './topTenBuyers/TopTenBuyers'
import UserGroupSelector from './userGroupSelector.jsx/UserGroupSelector'
import UserStatistics from './userStatistics/UserStatistics'

const Users = () => {
  return (
    <div>
      <UserStatistics />
      <TopTenBuyers />
      <UserGroupSelector />
    </div>
  )
}

export default Users